import {ThemeProvider as MuiThemeProvider} from '@mui/material'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import moment from 'moment'
import 'moment/locale/pt-br'
import {SnackbarProvider} from 'notistack'
import {useEffect, useState} from 'react'
import {AuthProvider} from 'src/contexts/AuthContext'
import usePersonalizedThemeByCompany, {CompaniesWithPersonalizedDashboards} from 'src/hooks/usePersonalizedThemeByCompany'
import RoutesPage from 'src/routes/RoutesPage'
import {ThemeProvider as StyledThemeProvider} from 'styled-components'
import SnackbarCloseButton from './components/SnackbarCloseButton'
import './services/debug'
import validateEnv from './utilities/validateEnv'

moment.locale('pt-br')
validateEnv()
const queryClient = new QueryClient({defaultOptions: {queries: {refetchOnWindowFocus: false, retry: 1}}})

export default function App() {
  const [isValidEnv, setIsValidEnv] = useState(false)

  if (!isValidEnv) setIsValidEnv(validateEnv())

  const {styledTheme, muiTheme} = usePersonalizedThemeByCompany()

  useEffect(() => {
    const favicon = document.getElementById('favicon') as HTMLLinkElement
    if (!favicon) return
    const url = window.location.href
    if (CompaniesWithPersonalizedDashboards.some((companyUrl) => url.includes(companyUrl))) favicon.href = process.env.PUBLIC_URL + '/sekronIcon.svg'
  }, [])

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
    }

    requestPermission()
  }, [])

  async function requestPermission() {
    await Notification.requestPermission()
  }

  return (
    <QueryClientProvider client={queryClient}>
      <StyledThemeProvider theme={styledTheme}>
        <MuiThemeProvider theme={muiTheme}>
          <AuthProvider>
            <SnackbarProvider
              action={(key) => <SnackbarCloseButton key={key} />}
              maxSnack={3}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              preventDuplicate={true}>
              <RoutesPage />
            </SnackbarProvider>
          </AuthProvider>
        </MuiThemeProvider>
      </StyledThemeProvider>
    </QueryClientProvider>
  )
}
